module.exports = __webpack_public_path__ + "img/logo-navbar.8740088c.svg";